import { FormikContextType } from 'formik';
import * as Yup from 'yup';

const TEXT_COPY = {
    REQUIRED: 'Required',
    INVALID_ACCESS_CODE: 'Event access code pattern invalid',
    ACCESS_CODE_PATTERN_INVALID:
        'Invalid access code pattern. Must be an alphanumeric code matching the pattern abcd-012345-ef',
    TERMS_AND_CONDITIONS: 'Must accept the Terms and conditions',
};
const BaseStringValidator = Yup.string().trim();

export enum Step {
    ACCESS_CODE_STEP_ONE = 'ACCESS_CODE_STEP_ONE',
    REVIEW_STEP_TWO = 'REVIEW_STEP_TWO',
}

export const FormSchema = Yup.object({
    [Step.ACCESS_CODE_STEP_ONE]: Yup.object({
        accessCode: BaseStringValidator.matches(
            /^[a-f0-9]{4}-[a-f0-9]{6}-[a-f0-9]{2}$/,
            TEXT_COPY.ACCESS_CODE_PATTERN_INVALID
        ).required(TEXT_COPY.REQUIRED),
    }),
    [Step.REVIEW_STEP_TWO]: Yup.object({
        eventName: BaseStringValidator.default(''),
        description: BaseStringValidator.default(''),
        startTime: BaseStringValidator.default(''),
        duration: Yup.number().default(-1),
        level: BaseStringValidator.optional().default(''),
        termsAndConditions: Yup.boolean()
            .oneOf([true], TEXT_COPY.TERMS_AND_CONDITIONS)
            .required(TEXT_COPY.REQUIRED),
    }),
});

export type FormSchemaType = Yup.InferType<typeof FormSchema>;

export type StepValidator = (
    param: FormikContextType<FormSchemaType>
) => Promise<boolean>;
